import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { MessagesStore } from '../stores';
import { IMessage } from '../../../interfaces/IMessage';
import IAMessagesCardView from '../../messagesCardView/MessagesCardView';
import { IItem } from '../../../interfaces/IItem';
import { ILike } from '../../../interfaces/ILike';
import { ILabel } from '../../../interfaces/ILabel';
import { LocalizationService } from '../../../services/LocalizationService';
import { Helper } from '../../../Helper';

export interface ICardViewProps {
  messagesStore?: MessagesStore;
}

@inject('messagesStore')
@observer
export default class CardView extends React.Component<ICardViewProps> {

  private localizationService: LocalizationService = new LocalizationService();

  public componentDidMount(): void {
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    let items: IItem[] = [];
    let itemsToShow: IMessage[] = [];
    const teaserEnabled = !!(this.props.messagesStore.instance?.settings?.enableTeaser || localStorage.getItem("enableTeaser"));
    if (this.props.messagesStore.messages) {
      if (this.props.messagesStore.isMobile) {
        itemsToShow = this.props.messagesStore.messages;
      } else {
        const startIndex = (this.props.messagesStore.pageNumber - 1) * this.props.messagesStore.numMessages;
        const endIndex = this.props.messagesStore.pageNumber * this.props.messagesStore.numMessages;
        itemsToShow = this.props.messagesStore.messages.slice(startIndex, endIndex)
      }

      itemsToShow.forEach((message: IMessage, index) => {
        let content = message.content;
        if (!content) {
          content = "";
        }
        let div = document.createElement("div");
        div.innerHTML = content.replace(/<\/p>/g, "</p> ").replace(/<\/h1>/g, "</h1> ").replace(/<\/h2>/g, "</h2> ").replace(/<\/li>/g, "</li> ");
        div.innerHTML = div.innerHTML.replace(/\>/g, "/> ");
        div.innerHTML = div.innerHTML.replace(/"  "/g, " ");
        let contentText = teaserEnabled && message.teaser ? message.teaser : (div.textContent || div.innerText || "");
        let author = message.author;
        if (message.contacts != undefined && message.contacts.length > 0) {
          author = message.contacts[0];
        }
        let labels: ILabel[];
        if (this.props.messagesStore.isAdminPage) {
          // Status
          let statusColor = "green";
          let statusIconUrl = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Checkmark%20Circle/SVG/ic_fluent_checkmark_circle_48_filled.svg";
          let statusText = this.localizationService.strings.ContentCreator_Active;

          if (message) {
            if (message.isDraft) {
              statusColor = "#777777";
              statusIconUrl = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Circle%20Edit/SVG/ic_fluent_circle_edit_24_filled.svg"; // "StatusDraft";
              statusText = this.localizationService.strings.ContentCreator_Draft;
            }
            else {
              if (message.endDate && new Date(message.endDate).valueOf() < new Date().valueOf()) {
                statusColor = "red";
                statusIconUrl = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Clock/SVG/ic_fluent_clock_48_filled.svg"; //"StatusPending";
                statusText = this.localizationService.strings.ContentCreator_Expired;
              }
              if (message.startDate && new Date(message.startDate).valueOf() > new Date().valueOf()) {
                statusColor = "orange";
                statusIconUrl = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Clock/SVG/ic_fluent_clock_48_filled.svg"; //"StatusPending";
                statusText = this.localizationService.strings.ContentCreator_Scheduled;
              }
              if (message.approvalStatus === "Pending") {
                statusColor = "#777777";
                statusIconUrl = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Approvals%20App/SVG/ic_fluent_approvals_app_32_regular.svg"; //"StatusDraft";
                statusText = this.localizationService.strings.ContentCreator_ApprovalStatusPending;
              }
              if (message.approvalStatus === "Rejected") {
                statusColor = "red";
                statusIconUrl = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Dismiss%20Circle/SVG/ic_fluent_dismiss_circle_48_filled.svg"; //"StatusPending";
                statusText = this.localizationService.strings.ContentCreator_ApprovalStatusRejected;
              }
            }
          }
          if (labels == undefined) {
            labels = [];
          }
          labels.push(
            {
              iconUrl: statusIconUrl,
              tooltip: statusText,
              backgroundColor: "transparent",
              textColor: statusColor,
              borderRadius: 5
            }
          );
          if (this.props.messagesStore.instance?.settings?.enablePinMessages && message.isPinned) {
            labels.push(
              {
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Pin/SVG/ic_fluent_pin_48_filled.svg",
                backgroundColor: "transparent",
                textColor: message.pinnedEndDate > new Date() ? "green" : "orange",
                borderRadius: 5
              }
            );
          }
          if (message.iaTargetingTargetContent) {
            labels.push(
              {
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/People%20Checkmark/SVG/ic_fluent_people_checkmark_24_regular.svg",
                tooltip: this.localizationService.strings.Card_ContentIsTargeted,
                backgroundColor: "transparent",
                textColor: "#777777",
                borderRadius: 5
              }
            );
          }
          if (message.feeds) {
            labels.push(
              {
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/RSS/SVG/ic_fluent_rss_24_regular.svg",
                tooltip: this.localizationService.strings.Card_ContentIsSharedInFeed,
                backgroundColor: "transparent",
                textColor: "#777777",
                borderRadius: 5
              }
            );
          }
          if (message.sendUsingBot) {
            labels.push(
              {
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Alert/SVG/ic_fluent_alert_48_regular.svg",
                tooltip: this.localizationService.strings.Card_PlingSend,
                backgroundColor: "transparent",
                textColor: "#777777",
                borderRadius: 5
              }
            );
          }
        }
        let videoUrl = message?.videoUrl;
        if ((location.href.includes("sharepoint.com") && message?.videoEmbedCode) || (videoUrl == undefined && message?.videoEmbedCode)) {
          videoUrl = Helper.getVideoSrcFromEmbedCode(message.videoEmbedCode);
        }
        items.push(
          {
            index: index,
            id: message.id.toString(),
            title: message.title,
            content: contentText,
            author: author,
            startDate: message.startDate,
            endDate: message.endDate,
            isAllDayEvent: message.allDayEvent,
            image: message.image,
            iaConfiguration: message.iaConfiguration,
            videoUrl: videoUrl,
            location: message.location,
            categories: message.categories,
            likes: message.likes,
            commentCount: message.commentCount,
            uniqueViews: message.uniqueViews,
            item: message,
            isUnread: !message.isRead && this.props.messagesStore.instance?.settings?.enableReadUnreadMessage && !this.props.messagesStore.isAdminPage,
            labels: labels,
            isPinned: message.isPinned && (new Date(message.pinnedEndDate) > new Date()) && !this.props.messagesStore.isAdminPage,
            iaMessageBgImagesFromBlob: message.iaMessageBgImagesFromBlob,
            external: message.external,
          }
        );
      });
    }
    return (
      <IAMessagesCardView
        items={items}
        width={this.props.messagesStore.width}
        fontSlots={this.props.messagesStore.fontSlots}
        cardPadding={20}
        minCardWidth={212}
        type={this.props.messagesStore.component === "Messages" ? "Message" : this.props.messagesStore.component as "Event" | "Message" | "ContentCreator" | "ContentOrganizer"}
        numberOfCards={this.props.messagesStore.numMessages}
        likesEnabled={this.props.messagesStore.likesEnabled}
        commentsEnabled={this.props.messagesStore.commentsEnabled}
        tenant={this.props.messagesStore.tenant}
        instanceName={this.props.messagesStore.instance?.instanceName}
        token={this.props.messagesStore.token}
        isMobile={this.props.messagesStore.isMobile}
        environment={this.props.messagesStore.environment}
        user={this.props.messagesStore.user}
        userRole={this.props.messagesStore.userRole}
        titleColor={this.props.messagesStore.headLineColor}
        textColor={this.props.messagesStore.textColor}
        highlightColor={this.props.messagesStore.rollupHighlightColor}
        borderColor={this.props.messagesStore.borderColor}
        borderRadius={this.props.messagesStore.borderRadius}
        backgroundColor={this.props.messagesStore.backgroundColor}
        loading={this.props.messagesStore.isMobile && this.props.messagesStore.messages && this.props.messagesStore.messages.length > 0 ? false : this.props.messagesStore.loading}
        showCommandBarItems={this.props.messagesStore.showCommandBarItems}
        showImage={this.props.messagesStore.showImage}
        showTitle={this.props.messagesStore.showTitle}
        showCategories={this.props.messagesStore.showCategories}
        showTeaser={this.props.messagesStore.showTeaser}
        showAuthor={this.props.messagesStore.showAuthor}
        displayDateOnCover={this.props.messagesStore.displayDateOnCover}
        showStartDate={this.props.messagesStore.showStartDate}
        showLikes={this.props.messagesStore.showLikes}
        showComments={this.props.messagesStore.showComments}
        showDropShadow={this.props.messagesStore.showDropShadow}
        showTimespand={this.props.messagesStore.showTimespand}
        showLocation={this.props.messagesStore.showLocation}
        showUniqueViews={this.props.messagesStore.showUniqueViews}
        hasDarkBackground={this.props.messagesStore.hasDarkBackground}
        maxAmountOfColumns={this.props.messagesStore.maxAmountOfColumns}
        onClickEdit={(itemToEdit: any) => {
          if (this.props.messagesStore.instance && itemToEdit?.iaConfiguration?.composerComponents) {
            this.props.messagesStore.editMessage(itemToEdit);
          } else {
            this.props.messagesStore.showConvertToComposerPopup = itemToEdit;
          }
        }}
        onClickDelete={(itemToDelete: any) => this.props.messagesStore.messageToDelete = itemToDelete}
        onClickOpen={(itemToOpen: any) => this.props.messagesStore.openMessage(itemToOpen)}
        isPanelOpen={this.props.messagesStore.panelIsOpen}
        showEmojiPickerExpandButton={this.props.messagesStore.instance?.settings?.showEmojiPickerExpandButton}
        reactionOptions={this.props.messagesStore.instance?.settings?.reactionOptions}
        likesUpdated={(message: IMessage, likes: ILike[]) => {
          message.likes = likes;
        }}
        commentsUpdated={(message: IMessage, commentCount: number) => {
          message.commentCount = commentCount;
        }}
        commentsClick={(message: IMessage) => this.props.messagesStore.commentsClick(message)}
        unReadHighlight={this.props.messagesStore.instance?.settings?.highlightUnread}
        showLikesDimmed={this.props.messagesStore.loadingCommentsAndLikes && this.props.messagesStore.showLikes}
        showCommentsDimmed={this.props.messagesStore.loadingCommentsAndLikes && this.props.messagesStore.showComments}
        showUniqueViewsDimmed={this.props.messagesStore.loadingUniqueViews && this.props.messagesStore.showUniqueViews}
        hideCommandBarButton={!this.props.messagesStore.isAdminPage}
        userLocation={this.props.messagesStore.userLocation}
        onClickCopy={(item) => {
          const itemCopy: IMessage = {
            ...JSON.parse(JSON.stringify(item)),
            id: undefined,
            startDate: new Date()
          };
          this.props.messagesStore.editMessage(itemCopy);
        }}
      />
    );
  }


}